import React, { Component, useState, useEffect } from "react"
import { Autocomplete, Box, Chip, Checkbox, Button, DataGrid, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, MenuItem, InputLabel, Select, TextField, Typography } from "@coolblue-development/becky"
import { QuestionmarkCircled, Cross } from "@coolblue-development/icons";
import Edit from '@mui/icons-material/Edit';
import {red, green, blue, gray, peppermint, antarcticblue} from '../../SharedComponents/Colors'
import { info } from "../../Form/Info";
import { platformArray, hostnameArray } from "../../Form/StandardMetricsDimsMap";
import dayjs from 'dayjs';
import ListItemText from '@mui/material/ListItemText';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, NavLink } from "react-router-dom";
import  fetchDetails from '../BackendAPI/fetchDetailsData'
import  SaveData from '../BackendAPI/SaveData'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Switch from '@mui/material/Switch';
import { useAuth } from '@coolblue-development/react-cognito-sso-auth';
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

var utc = require("dayjs/plugin/utc");
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);


export default function TestDetails() {
    const navigate = useNavigate();
    const [details, setDetails] = useState(() => { // here we look if there are values saved, otherwise defaults are used
    const savedValues = localStorage.getItem('details');
    return savedValues ? JSON.parse(savedValues) : {
      campaign_name: null,
      confluence_link: null,
      start_date: dayjs.tz(dayjs(), 'Europe/Amsterdam').format('YYYY-MM-DD'), // today as default
      end_date: dayjs.tz(dayjs(), 'Europe/Amsterdam').format('YYYY-MM-DD'), // today as default
      event_name: null,
      event_key: null,
      event_param: null,
      context: null,
      feature: null,
      sub_feature: null,
      platform: null,
      hostname: null,
      pagelocation: null,
      excluded_page_location: null,
      active: 0, // have inactive as default
      domain: 'STAD', // STAD is the default domain
      label: 'Pre_cart', // Pre_cart is the default label
      metric: 'add_to_cart', // add_to_cart as default
      second_metric: 'bounce_rate', // bounce_rate as default
      custom_metric: null,
      custom_event_name: null,
      custom_context: null,
      custom_feature: null,
      custom_sub_feature: null,
      extra_filter_event_name: null,
      extra_filter_context: null,
      extra_filter_feature: null,
      extra_filter_sub_feature: null,
      comments: null,
      impact: null,
      error: null,
      multi_armed_bandit: null,
      multi_armed_bandit_2: null,
      limit_alerting: null,
    };
  });
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);
    const [platform, setPlatform] = useState([]);
    const [metricLabel, setMetricLabel] = useState(['Pre_cart']);
    const [metric, setMetric] = useState(['add_to_cart']);
    const [secondMetric, setSecondMetric] = useState(['bounce_rate']);
    const [domain, setDomain] = useState(['STAD']);
    const [hostname, setHostname] = useState();
    const [campaignIdHelpertext, setCampaignIdHelpertext] = useState('');
    const [pagelocationHelpertext, setPagelocationHelpertext] = useState('');
    const [excludedPageLocationHelpertext, setExcludedPageLocationHelpertext] = useState('');
    const [eventNameHelpertext, setEventNameHelpertext] = useState('');
    const [eventKeyHelpertext, setEventKeyHelpertext] = useState('');
    const [eventParamHelpertext, setEventParamHelpertext] = useState('');
    const [contextHelpertext, setContextHelpertext] = useState('');
    const [featureHelpertext, setFeatureHelpertext] = useState('');
    const [subFeatureHelpertext, setSubFeatureHelpertext] = useState('');
    const [customMetricHelpertext, setCustomMetricHelpertext] = useState('');
    const [customEventNameHelpertext, setCustomEventNameHelpertext] = useState('');
    const [customContextHelpertext, setCustomContextHelpertext] = useState('');
    const [customFeatureHelpertext, setCustomFeatureHelpertext] = useState('');
    const [customSubFeatureHelpertext, setCustomSubFeatureHelpertext] = useState('');
    const devices = ["desktop", "mobile", "tablet", "app"];
    const hostnames = ["\\.nl$", "\\.be$", "\\.de$"];
    const metrics = [ "bounce_rate", "add_to_cart", "placed_order_conversion", "product_page_seen", "search_page_seen", "login_rate", "logout_rate", "b_i_insurance", "b_i_service", "c_i_attached_product_margin_including_all_agreements", "c_i_attached_product_margin_including_all_agreements_all_orders", "c_i_attached_product_quantity", "c_i_attached_product_quantity_all_orders", "c_i_invoice_product_margin_including_all_agreements", "c_i_primary_product_margin_including_all_agreements", "c_i_transaction_margin", "c_v_transaction_margin", "sales", "checkout_seen", "checkout_conversion_rate", "shopping_cart_continuation_rate", "shopping_cart_conversion_rate", "contact_option_phone_clicked", "contact_option_email_clicked", "contact_option_whatsapp_clicked", "contact_option_callmeback_clicked", "contact_option_livechat_clicked", "contact_option_email_energy_clicked", "contact_option_phone_energy_clicked", "contact_option_email_business_clicked", "contact_option_clicked", "return_request_form_clicked", "cross_sell_orders", "login_page_seen", "login_page_continuation_rate", "login_page_conversion_rate", "details_page_seen", "details_page_continuation_rate", "details_page_conversion_rate", "delivery_method_page_seen", "delivery_method_page_continuation_rate", "delivery_method_page_conversion_rate", "coolblue_timeslot_page_continuation_rate", "coolblue_timeslot_page_conversion_rate", "checkout_delivery_partner_pickup_page_continuation_session", "checkout_delivery_partner_pickup_page_seen", "payment_page_continuation_rate", "payment_page_conversion_rate", "overview_page_continuation_rate", "overview_page_conversion_rate", "thank_you_page_seen", "customer_not_at_home_failure_rate", "service_cancelled_failure_rate", "order_refused_by_customer_failure_rate", "address_incorrect_failure_rate", "address_not_found_failure_rate", "additional_hero_needed_failure_rate", "environmental_return_aftercare_failure_rate", "order_information_success_rate", "solar_start_form", "solar_form_conversion", "solar_web_conversion", "heat_pumps_start_form", "heat_pumps_web_conversion", "heat_pumps_form_conversion", "energy_web_conversion", "energy_start_form", "energy_form_conversion", "homepage_button_clicked", "charging_stations_start_form", "charging_stations_form_conversion", "charging_stations_web_conversion", "energy_offer_conversion", "energy_offer_duration", "energy_offer_value", "visit_to_apply_rate", "form_entry_rate", "vacancy_page_selected", "custom"];
    const metriclabels = [ "Pre_cart", "Cross_sell", "Checkout", "App_Checkout", "Solar_Panels", "Energy", "energy_contracts_offers", "Charging_Stations", "Recruitment", "Heat_Pumps"];
    const domains = [ "Energy", "Energy Contracts Offers", "Heat Pumps", "Germany", "Mobile Apps", "Self Service", "Ordering", "Payments", "Upsell", "Cross-sell", "Storefront", "SEO", "Product Support", "Returns, repairs & recovery", "Solar Panels", "Stores", "Recruitment", "Charging stations", "Business Journeys", "Design system", "STAD", "Paid Search Marketing", "Customer Recognition & Customer Data", "Pricing", "Delivery & Installation Services"];
    const auth = useAuth();
    const token = auth.user.token;
    fetchDetails(setDetails, setLoading, setPlatform, setDomain, setMetricLabel, setMetric, setSecondMetric, setHostname, token);

    useEffect(() => {
        console.log(details);
    }, [details]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { target } = event;
        setDetails((prevState) => ({
            ...prevState,
            [target.name]: target.value,
        }));
        if (target.name === 'active') {
            setDetails((prevState) => ({
                ...prevState,
                [target.name]: target.checked,
            }));
        }
    };

    const handleStartDateChange = (newValue): void => {
        setDetails((prevState) => ({
            ...prevState,
            ['start_date']: dayjs.tz(newValue, 'Europe/Amsterdam').format('YYYY-MM-DD'),
        }));
    };

    const handleEndDateChange = (newValue): void => {
        setDetails((prevState) => ({
            ...prevState,
            ['end_date']: dayjs.tz(newValue, 'Europe/Amsterdam').format('YYYY-MM-DD'),
        }));
    };

    const handleDeviceChange = (event) => {
        const { target: { value }, } = event;
        setDetails((prevState) => ({
            ...prevState,
            ['platform']: typeof value === 'string' ? value.split('|') : value,
        }));
        setPlatform(typeof value === 'string' ? value.split('|') : value,)
    };

    const handleHostnameChange = (event) => {
        const { target: { value }, } = event;
        setDetails((prevState) => ({
            ...prevState,
            ['hostname']: typeof value === 'string' ? value.split('|') : value,
        }));
        setHostname(typeof value === 'string' ? value.split('|') : value,)
    };

    const handleMetricLabelChange = (event) => {
        const { target: { value }, } = event;
        setDetails((prevState) => ({
            ...prevState,
            ['label']: value,
        }));
        setMetricLabel(value)
    };

    const handleMetricChange = (event) => {
        const { target: { value }, } = event;
        setDetails((prevState) => ({
            ...prevState,
            ['metric']: value,
        }));
        setMetric(value)
    };

    const handleSecondMetricChange = (event) => {
        const { target: { value }, } = event;
        setDetails((prevState) => ({
            ...prevState,
            ['second_metric']: value,
        }));
        setSecondMetric(value)
    };

    const handleDomainChange = (event) => {
        const { target: { value }, } = event;
        setDetails((prevState) => ({
            ...prevState,
            ['domain']: value,
        }));
        setDomain(value)
    };

    const changeCampaignIdHelpertext = (event) => {
        const { target: { value }, } = event;
        const regex = /^[a-zA-Z0-9]{6}$/g;
        const found = value.match(regex);
        if (!found) {
            setCampaignIdHelpertext('Are you sure this is valid?')
        }
        else {
            setCampaignIdHelpertext('')
        }
    };

    const changeRegexHelpertext = (event, set) => {
        const { target: { value }, } = event;
        var isValid = true;
        try {
            new RegExp(value);
        } catch(e) {
            isValid = false;
        }
        if(!isValid) {
            set('Regex is not valid')
        }
        else {
            set('')
        }
    };

    const changeCustomMetricHelperText = (event) => {
        const { target: { value }, } = event;
        const regex = /^[a-zA-Z]*$/g;
        const found = value.match(regex);
        if (!found) {
            setCustomMetricHelpertext('No spaces or funky chars')
        }
        else {
            setCustomMetricHelpertext('')
        }
    };
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState("");
    const handleOpen = (fieldTopic): void => {
		setOpen(true);
		setContent(info[fieldTopic]);
	};
	const handleClose = (): void => {
		setOpen(false);
	};



    return (
    <Grid container>
        <Grid item xs={12}>
            <Box>
                <Typography variant="h2" gutterBottom component="div">
                    General information
                </Typography>
            </Box>
        </Grid>
        <Grid container xs={12} paddingTop={4} paddingBottom={4}>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="campaign_name"
                   label="Campaign name"
                   placeholder="e.g. 'Beste idee evah ;)'"
                   value={details.campaign_name}
                   onChange={handleChange}
                />
            </ Grid>
            <Grid item xs={1} paddingBottom={4} paddingRight={6}>
                <TextField
                   name="campaign_id"
                   label="CampaignId"
                   placeholder="e.g. '1s4g41'"
                   helperText={campaignIdHelpertext}
                   value={details.campaign_id}
                   onChange={e => { handleChange(e); changeCampaignIdHelpertext(e) }}
                />
            </Grid>
            <Grid item xs={2} paddingBottom={4} paddingRight={6}>
                    <FormControl fullWidth>
                        <InputLabel id="domain">
                            Domain
                            </InputLabel>
                            <Select
                                labelId="domainlabel"
                                id="domain"
                                defaultValue={domain}
                                value={domain}
                                onChange={handleDomainChange}
                                label="Domain"
                            >
                                {domains.map((name) => (
                                    <MenuItem value={name}>{name}</MenuItem>
                                ))}
                            </Select>
                    </FormControl>
            </Grid>
            <Grid item xs={4} paddingBottom={4} paddingRight={6}>
               <Autocomplete fullWidth
                 multiple
                 name="platform"
                 value={platform}
                 onChange={(event, newValue) => {
                   setPlatform(newValue);
                   setDetails((prevState) => ({
                       ...prevState,
                       ['platform']: newValue,
                   }));
                 }}
                 options={platformArray}
                 filterSelectedOptions
                 renderInput={(params: AutocompleteRenderInputParams): ReactNode => (
                   <TextField {...params} label="Platforms" placeholder="Type to filter…" />
                 )}
               />


            </Grid>

            <Grid item xs={2} paddingBottom={4}>
                <FormLabel component="legend" >Active </FormLabel>
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    size="medium"
                    control={<Switch size="medium" name="active" checked={details.active} onChange={handleChange} />}
                  />
                </FormGroup>
            </Grid>
        </Grid>
        <Grid container xs={12} paddingBottom={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid item xs={2} paddingRight={6} >
                    <DatePicker
                        name="start_date"
                        label="Start date"
                        value={dayjs(details.start_date)}
                        onChange={(newValue) => handleStartDateChange(newValue)}
                    />
                </Grid>
                <Grid item xs={2} paddingRight={6} >
                    <DatePicker
                        label="End date"
                        value={dayjs(details.end_date)}
                        onChange={(newValue) => handleEndDateChange(newValue)}
                    />
                </Grid>
            </ LocalizationProvider>
        </Grid>
        <Grid container xs={12}>
            <Grid item xs={6} paddingRight={6}>
                <TextField fullWidth
                   name="confluence_link"
                   label="Confluence Link"
                   placeholder="https://coolblue.atlassian.net/wiki/spaces/KCSTAD/pages/"
                   value={details.confluence_link}
                   onChange={e => { handleChange(e);}}
                    />
            </Grid>
            <Grid item xs={2} paddingRight={6}>
                <TextField fullWidth
                   name="impact"
                   label="Impact"
                   placeholder="123456.12"
                   value={details.impact}
                   onChange={e => { handleChange(e);}}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("impact")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                    />
              </Grid>
        </Grid>
        <Grid item xs={12} paddingTop={4} paddingBottom={4}>
            <Divider />
        </Grid>
        <Grid item xs={12}>
            <Box>
                <Typography variant="h2" gutterBottom component="div">
                    When to track a visitor
                </Typography>
            </Box>
        </Grid>
        <Grid container xs={12} paddingBottom={4} paddingTop={4}>
            <Grid item xs={3} paddingBottom={4} paddingRight={6}>
                <Autocomplete fullWidth
                 multiple
                 name="hostname"
                 value={hostname}
                 onChange={(event, newValue) => {
                   setHostname(newValue);
                   setDetails((prevState) => ({
                       ...prevState,
                       ['hostname']: newValue,
                   }));
                 }}
                 options={hostnameArray}
                 filterSelectedOptions
                 renderInput={(params: AutocompleteRenderInputParams): ReactNode => (
                   <TextField {...params} label="Subsidiary" placeholder="Click to filter…" />
                 )}
               />
            </Grid>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="pagelocation"
                   label="Pagelocation"
                   placeholder="\/product\/123456\/.*"
                   value={details.pagelocation}
                   helperText={pagelocationHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setPagelocationHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("page_location")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="excluded_page_location"
                   label="Excluded pagepaths"
                   placeholder="\/product\/123456\/.*"
                   value={details.excluded_page_location}
                   helperText={excludedPageLocationHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setExcludedPageLocationHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("excluded_pagepaths")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
        </Grid>
        <Grid container xs={12} paddingBottom={4}>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="event_name"
                   label="Event name"
                   placeholder="screen_view"
                   value={details.event_name}
                   helperText={eventNameHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setEventNameHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("event_name")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="event_key"
                   label="Event param key"
                   placeholder="productid"
                   value={details.event_key}
                   helperText={eventKeyHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setEventKeyHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("event_params_key")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="event_param"
                   label="Event param value"
                   placeholder="870040"
                   value={details.event_param}
                   helperText={eventParamHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setEventParamHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("event_params_value")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
        </Grid>
         <Grid container xs={12} paddingBottom={4}>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="context"
                   label="Context"
                   placeholder="product_page"
                   value={details.context}
                   helperText={contextHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setContextHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("context")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="feature"
                   label="Feature"
                   placeholder="Add to cart button"
                   value={details.feature}
                   helperText={featureHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setFeatureHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("feature")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
            <Grid item xs={3} paddingRight={6}>
                <TextField fullWidth
                   name="sub_feature"
                   label="Sub-feature"
                   placeholder="Add to cart button"
                   value={details.sub_feature}
                   helperText={subFeatureHelpertext}
                   onChange={e => { handleChange(e); changeRegexHelpertext(e, setSubFeatureHelpertext) }}
                   InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("sub_feature")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                />
            </ Grid>
        </Grid>
        <Grid item xs={12} paddingTop={4} paddingBottom={4}>
            <Divider />
        </Grid>
        <Grid item xs={12}>
            <Box>
                <Typography variant="h2" gutterBottom component="div">
                    Which metrics to monitor
                </Typography>
            </Box>
        </Grid>
        <Grid container xs={12} paddingBottom={4} paddingTop={4}>
            <Grid item xs={3} paddingBottom={4}>
                <Box paddingRight={4}>
                    <FormControl fullWidth>
                        <InputLabel id="MetricLabel">Metric Label</InputLabel>
                            <Select labelId="MetricLabel" id="MetricLabel" defaultValue={metricLabel} value={metricLabel} label="Metric Label" onChange={handleMetricLabelChange}>
                                {metriclabels.map((name) => (
                                    <MenuItem value={name}>{name}</MenuItem>
                                ))}
                            </Select>
                    </FormControl>
                </Box>
            </Grid>
            <Grid item xs={3} paddingBottom={4}>
                <Box paddingRight={4}>
                    <FormControl fullWidth>
                        <InputLabel id="Metric">Metric</InputLabel>
                            <Select labelId="Metric" id="Metric" defaultValue={metric} value={metric} label="Metric" onChange={handleMetricChange}>
                              {metrics.map((name) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                    </FormControl>
                </Box>
            </Grid>
            <Grid item xs={3} paddingBottom={4}>
                <Box paddingRight={4}>
                    <FormControl fullWidth>
                        <InputLabel id="SecondMetric">Second Metric</InputLabel>
                            <Select labelId="SecondMetric" id="SecondMetric" defaultValue={secondMetric} value={secondMetric} label="SecondMetric" onChange={handleSecondMetricChange}>
                              {metrics.map((name) => (
                                <MenuItem value={name}>{name}</MenuItem>
                              ))}
                            </Select>
                    </FormControl>
                </Box>
            </Grid>
        </Grid>
        { (details.metric === 'custom' || details.second_metric === 'custom') && (
            <><Grid container xs={12} paddingBottom={4}>
                <Grid item xs={3} paddingRight={6}>
                    <TextField fullWidth
                       name="custom_metric"
                       label="Custom metric name"
                       placeholder="clicked_the_button"
                       value={details.custom_metric}
                       helperText={customMetricHelpertext}
                       onChange={e => { handleChange(e); changeCustomMetricHelperText(e) }}
                       InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("custom_metric_name")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                    />
                </ Grid>
                <Grid item xs={3} paddingRight={6}>
                    <TextField fullWidth
                       name="custom_event_name"
                       label="Custom event name"
                       placeholder="screen_view"
                       value={details.custom_event_name}
                       helperText={customEventNameHelpertext}
                       onChange={e => { handleChange(e); changeRegexHelpertext(e, setCustomEventNameHelpertext) }}
                       InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("custom_event_name")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                    />
                </ Grid>
                <Grid item xs={3} paddingRight={6}>
                    <TextField fullWidth
                       name="custom_context"
                       label="Custom context"
                       placeholder="product_page"
                       value={details.custom_context}
                       helperText={customContextHelpertext}
                       onChange={e => { handleChange(e); changeRegexHelpertext(e, setCustomContextHelpertext) }}
                       InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("custom_context")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                    />
                </ Grid>
                <Grid item xs={3} paddingRight={6}>
                    <TextField fullWidth
                       name="custom_feature"
                       label="Custom feature"
                       placeholder="CTA"
                       value={details.custom_feature}
                       helperText={customFeatureHelpertext}
                       onChange={e => { handleChange(e); changeRegexHelpertext(e, setCustomFeatureHelpertext) }}
                       InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("custom_feature")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                    />
                </ Grid>
            </Grid>
            <Grid container xs={12} paddingBottom={4}>
                <Grid item xs={3} paddingRight={6}>
                    <TextField fullWidth
                       name="custom_sub_feature"
                       label="Custom sub feature"
                       placeholder="CTA"
                       value={details.custom_sub_feature}
                       helperText={customSubFeatureHelpertext}
                       onChange={e => { handleChange(e); changeRegexHelpertext(e, setCustomSubFeatureHelpertext) }}
                       InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleOpen("custom_sub_feature")}>
                                    <QuestionmarkCircled />
                                </IconButton>{" "}
                            </InputAdornment>
                        ),
                    }}
                    />
                </ Grid>
            </Grid></>
        )}
        <Grid container xs={12} paddingBottom={4}>
            <Grid item xs={2} paddingTop={4}>
                <Box>
                    <Button
                        preset="callToAction"
                        onClick={() => SaveData(details, setLoading, token)}
                        loading={loading}
                        disabled={details.campaign_id === 'new'}
                    >
                        Save configuration
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={2} paddingTop={4}>
                <Box>
                    <Button
                        component={NavLink}
						to="/">
                        Return to overview
                    </Button>
                </Box>
            </Grid>
        </Grid>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                A little help
                <IconButton
                    onClick={handleClose}
                    preset="text"
                    size="small"
                    aria-label="Close dialog"
                >
                    <Cross />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{content}</DialogContentText>
            </DialogContent>
        </Dialog>
    </Grid>

    );
}
